<template>
  <div v-if="data" class="clg__wrapper">
    <ProductCard
      v-for="product in data.products"
      type="TypeA"
      :key="product.handle"
      :product="product"
      :callouts="data.callouts"
      :quickview="true"
      :scrollImagesTest="scrollImagesTest"
    />
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted, onUnmounted } from 'vue';
  import { useStore } from 'vuex';
  import ProductCard from '../global/product-card/index.vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
  });

  const store = useStore();
  const scrollImagesTest = ref(null);


  onMounted(() => {
    store.dispatch('fetchWishlistItems');
    window.refreshYotpoData();
    window.addEventListener('refreshWishlist', refreshWishlist);
  });

  onUnmounted(() => {
    window.removeEventListener('refreshWishlist', refreshWishlist);
  });

  const refreshWishlist = () => {
    store.dispatch('fetchWishlistItems');
  };
</script>
